
<div class="modal-header">
    <button type="button" (click)="onClickClose()" class="close" aria-label="Close"><span aria-hidden="true">&times;</span></button>
    <h4 class="modal-title" style="text-align:center; color: #002c7c; font-weight: bold;">{{ titulo }}!</h4>
  </div>
  <div class="modal-body">
    <div class="row">
      <div class="col-xs-12 text-modal aligned">
        <h4>As alterações realizadas nesta tela serão perdidas.</h4>
        <h4>Deseja continuar?</h4>
      </div>
    </div>
  </div>
  <div class="modal-footer space">
    <button *ngIf="showFecharBtn" type="button" class="btn btn-border-orange pull-left" (click)="onClickClose()">{{ labelFechar }}</button>
    <button *ngIf="showOkBtn" type="button" class="btn btn-full-orange pull-right" (click)="onClickOk()">{{ labelOk }}</button>
  </div>
